import { isPlatformServer } from '@angular/common';
import { DestroyRef, inject, Injectable, makeStateKey, OnInit, PLATFORM_ID, signal, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TransferState } from '@angular/platform-browser';
import { HotelData } from '@core/models/DTOs/hotel.dto';
import { InternationalHotelsRepository } from '@core/services/repositories/international-hotels.repository';
import { Observable, tap } from 'rxjs';


const HOTELS_KEY = makeStateKey<any[]>('intl-hotels');

@Injectable({
  providedIn: 'root'
})
export class iranHotelsService {
  cityState: WritableSignal<HotelData | null | undefined> = signal(null);
  private transferState = inject(TransferState);
  private platformId = inject(PLATFORM_ID);
  private destroyRef = inject(DestroyRef);
  private repo = inject(InternationalHotelsRepository)

  constructor() { }


  getIranHotels(): Observable<any> | void {
      const cached = this.transferState.get(HOTELS_KEY, null);
      const cityState$ = this.repo.getIranlHotels().pipe(
        tap((res: any) => {
          this.cityState.set(res);
          this.transferState.set(HOTELS_KEY, res);
        })
      );
  
      if (isPlatformServer(this.platformId)) {
        return cityState$; 
      } else {
        if (cached) {
          this.cityState.set(cached);
          this.transferState.remove(HOTELS_KEY); 
        } else {
          cityState$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
        }
      }
    }
}
